var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass: "boat-navigation__link",
      class: { _current: _setup.props.name === _setup.props.active },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _setup.click_scrollTo(_setup.props.name)
        },
      },
    },
    [
      _c(_setup.icon_comp(_vm.name), {
        tag: "component",
        staticClass: "boat-navigation__icon",
      }),
      _vm._v(" "),
      _vm._t("default", function () {
        return [_vm._v("Название")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }